export default __webpack_public_path__ + "static/media/open-padlock.f0b62851.svg";